"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var downloads_1 = require("./downloads");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.DownloadEventNames.Downloads] = downloads_1.downloads,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
